import { Box, HStack, VStack, Text, Progress, Icon } from '@chakra-ui/react';
import { FiCalendar } from 'react-icons/fi';
import { Quarter } from '../../types';
import { getCurrentQuarter, getCurrentYear } from '../vto.util';

interface CurrentQuarterTimelineProps {
  quarter: Quarter;
  year: number;
}

/**
 * Year-to-date timeline bar. Renders only when the selected quarter/year is the one
 * we're currently in, giving quick context on how far through the year we are.
 */
export function CurrentQuarterTimeline({ quarter, year }: CurrentQuarterTimelineProps) {
  const isCurrentPeriod = quarter === getCurrentQuarter() && year === getCurrentYear();
  if (!isCurrentPeriod) {
    return null;
  }

  const totalMonths = 12;
  const monthsElapsed = new Date().getMonth() + 1; // Jan = 1 ... Dec = 12
  const pct = (monthsElapsed / totalMonths) * 100;

  return (
    <Box bg="white" rounded="lg" p={4} shadow="sm" borderWidth="1px" borderColor="gray.200">
      <HStack spacing={2} mb={2}>
        <Icon as={FiCalendar} w={4} h={4} color="gray.600" />
        <Text fontSize="md" fontWeight="semibold" color="gray.700">
          Time Progress
        </Text>
      </HStack>
      <VStack spacing={2} align="stretch">
        <HStack justify="space-between" fontSize="sm">
          <Text color="gray.600">Elapsed:</Text>
          <Text fontWeight="semibold" color="gray.900">
            {monthsElapsed} of {totalMonths} months
          </Text>
        </HStack>
        <Progress value={Math.min(pct, 100)} colorScheme="gray" size="sm" rounded="full" />
        <Text fontSize="sm" color="gray.600">
          {pct.toFixed(1)}% of timeline complete
        </Text>
      </VStack>
    </Box>
  );
}
